// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  Impact,
  IncidentStatus,
  Source,
} from "./types";


export default __t.row({
  id: __t.u64().primaryKey(),
  title: __t.string(),
  get impact() {
    return Impact;
  },
  get status() {
    return IncidentStatus;
  },
  components: __t.array(__t.string()),
  get source() {
    return Source;
  },
  openedAt: __t.timestamp().name("opened_at"),
  updatedAt: __t.timestamp().name("updated_at"),
  resolvedAt: __t.option(__t.timestamp()).name("resolved_at"),
  auto: __t.bool(),
  alertGroupKey: __t.string().name("alert_group_key"),
});
